import {chain, pick, keyBy, get, createSelector} from 'helpers';
import {timestamp} from 'store/common';
import {activity, subtasks} from 'store/activities/selectors';

export const subtasksProgress = createSelector(
  [ state => state.activities.progress, state => state.activities.subs ],
  ( progress, subs) => keyBy(subs, subtask => {
    if (!subtask.name && !subtask.orderIndex) {
      return get(progress[subtask.parentStatusId], 'timestamp') + '_' + subtask.parentId;
    }
  })
);

export const subtasksChecklist = createSelector(
  [ activity, timestamp, subtasks, subtasksProgress ],
  ( activity, timestamp, subtasks = [], subtasksProgress ) => chain(subtasks).map(subtask => {
    if (activity.repeatType) {
      subtask = {
        ...subtask,
        ...pick(subtasksProgress[timestamp + '_' + subtask.id], 'status'),
      }
    }
    return subtask;
  }).sortBy(({ status }) => status == 'Completed' ? 1 : 0).value(),
  { memoizeOptions: { maxSize: 100 } },
);

export const subtaskOccurance = createSelector(
  [ timestamp, subtasksProgress ],
  ( timestamp, subtasksProgress ) => ({ id }) => subtasksProgress[timestamp + '_' + id],
  { memoizeOptions: { maxSize: 100 } },
);
